<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication">Remembering all those hours of</p>
<p class="center">gimlet-eyed literary criticism,</p>
<p class="center">I dedicate this book to Joe Gores</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3dedication.vue?1c9306d3